import { Component, OnInit } from '@angular/core';
import { Descarga } from 'src/app/models/descarga';
import { ActivatedRoute, Router } from '@angular/router';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { DescargaService } from 'src/app/services/descarga.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-cadastrar-descarga',
  templateUrl: './cadastrar-descarga.component.html',
  styleUrls: ['./cadastrar-descarga.component.scss']
})
export class CadastrarDescargaComponent implements OnInit {

  descarga: Descarga;
  idDescarga: string;
  carregando = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private descargaService: DescargaService,
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idDescarga = this.route.snapshot.paramMap.get('id');

      this.buscarDescarga();
    } else {
      this.descarga = new Descarga();
    }
  }

  buscarDescarga() {
    this.carregandoService.mostra('buscar');
    this.carregando = true;
    this.descargaService.consultarPorIdDescarga(this.idDescarga).subscribe(
      resp => {
        this.descarga = resp;
        this.carregandoService.esconde('buscar');
        this.carregando = false;
      },
      err => {
        this.carregandoService.esconde('buscar');
        this.notificacaoService.erro(err);
        this.carregando = false;
      }
    );
  }

  salvar() {
    this.carregandoService.mostra('salvar');
    this.descarga.percentual = Number(this.descarga.percentual);
    this.descargaService.salvar(this.descarga).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Descarga salva com sucesso!!');
        this.router.navigate(['/configuracoes/descarga']);
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }
}
